export { getCmdbFieldValueElement } from './web-component';
